import React, { useState } from 'react';

export default function ScreenshotUploadModal({
  isOpen,
  onClose,
  onContinue,
  title = 'Paste Screenshot',
  continueLabel = 'Continue to Form',
}) {
  const [pastedImage, setPastedImage] = useState(null);

  if (!isOpen) return null;

  const handlePasteFromClipboard = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();

      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type.startsWith('image/')) {
            const blob = await clipboardItem.getType(type);
            const imageUrl = URL.createObjectURL(blob);
            setPastedImage(imageUrl);
            return;
          }
        }
      }

      alert('No image found in clipboard. Please copy a screenshot first!');
    } catch (err) {
      console.error('Clipboard error:', err);
      alert(
        'Could not access clipboard. Please make sure you have copied a screenshot and granted clipboard permissions.'
      );
    }
  };

  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl w-full max-w-sm max-h-[calc(100%-2rem)] flex flex-col">
        <div className="flex items-center justify-between p-6 pb-0 shrink-0">
          <h2 className="text-xl font-bold text-gray-900">{title}</h2>
          <button
            onClick={() => {
              setPastedImage(null);
              onClose?.();
            }}
            className="p-2 -mr-2 hover:bg-gray-100 rounded-lg z-10"
            style={{ minWidth: 40, minHeight: 40 }}
          >
            ✕
          </button>
        </div>

        <div className="overflow-auto p-6 pt-4">
          {!pastedImage && (
            <>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center mb-4">
                <div className="text-sm text-gray-600 mb-2">
                  Paste a screenshot from your device
                </div>
              </div>

              <button
                onClick={handlePasteFromClipboard}
                className="w-full bg-gray-900 text-white rounded-lg p-3 font-medium hover:bg-gray-800 transition-colors"
              >
                Paste from Clipboard
              </button>
            </>
          )}

          {pastedImage && (
            <div>
              <div className="text-sm font-semibold text-gray-700 mb-2">Preview:</div>
              <img
                src={pastedImage}
                alt="Pasted screenshot"
                className="w-full rounded-lg border-2 border-gray-300"
              />

              <button
                onClick={() => {
                  const img = pastedImage;
                  setPastedImage(null);
                  onContinue?.(img);
                }}
                className="w-full mt-4 bg-blue-600 text-white rounded-lg p-3 font-medium hover:bg-blue-700 transition-colors"
              >
                {continueLabel}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}